import * as React from "react";
import ContentCard from "../../../../ui-library/content-card/content-card";
import CardContent from "../../../../ui-library/content-card/card-content";
import CardHeading from "../../../../ui-library/content-card/card-heading";
import { Global } from "@emotion/core";
import { amazonStyles } from "./amazon.styles";

const PittaMaskAds: React.FC = () => {
  React.useEffect(() => {
    const scriptTag = document.createElement("script");

    scriptTag.type = "text/javascript";
    scriptTag.text = `amzn_assoc_placement = "adunit0";
    amzn_assoc_div_name = "amzn_assoc_ad_div_adunit0_0"
    amzn_assoc_search_bar = "false";
    amzn_assoc_tracking_id = "askabout05-20";
    amzn_assoc_ad_mode = "manual";
    amzn_assoc_ad_type = "smart";
    amzn_assoc_marketplace = "amazon";
    amzn_assoc_region = "US";
    amzn_assoc_title = "";
    amzn_assoc_linkid = "1650cd92232750e98b8b1ab4ab34af19";
    amzn_assoc_asins = "B016A4ZWKW,B01N5JTY99,B07HR543GQ,B07HR2R485,B00IEOZRHU,B06XSH7VQ3,B00PRO3PB0,B01F8N0PQ2";`;

    const scriptLink = document.createElement("script");
    scriptLink.src = "//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US";
    scriptLink.async = false;

    document.body.appendChild(scriptTag);
    document.body.appendChild(scriptLink);

    return () => {
      document.body.removeChild(scriptTag);
      document.body.removeChild(scriptLink);
    };
  }, []);

  return (
    <ContentCard>
      <CardContent isNarrow={true}>
        <CardHeading>Pitta masks on Amazon</CardHeading>
        <div id="amzn_assoc_ad_div_adunit0_0" />
        <Global styles={amazonStyles} />
      </CardContent>
    </ContentCard>
  );
};

export default PittaMaskAds;
